import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from '../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications

import { JobTypeDocument } from '../../../shared/models/jobTypeDocument.model';

import { HotToastService } from '@ngneat/hot-toast';
import { BsModalService } from 'ngx-bootstrap/modal';
import { JobTypeAffidavit } from '../../../shared/models/jobTypeAffidavit.model';

// import { JobServiceRule } from '../../../shared/models/jobServiceRule.model';
import { JobServiceTimeframe } from './../../../shared/models/jobServiceTimeframe.model';
import { VariableCodeBlock } from 'src/app/shared/models/variableCodeBlockModel.model';


@Component({
  selector: 'app-variable-code-block-create-widget',
  templateUrl: './variable-code-block-create-widget.component.html',
  styleUrls: ['./variable-code-block-create-widget.component.scss']
})
export class VariableCodeBlockCreateWidgetComponent implements OnInit {


  // model: JobServiceTimeframe;
  model: VariableCodeBlock; 
  job_types: any;
  job_type_locations: any;
  count2: any;
  get_latest_court_id: any;
  job_type_courts: any;

  @Input() send_job_type_location_id: any;
  @Input() send_job_type_court_id: any;
  @Input() send_job_type_id: any;
  @Input() send_job_type_document_type_id: any;


  get_latest_affidavit_id: any;
    get_latest_document_id: any;
  job_type_document_types: any;
  
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();
  sent_job_type_court_id: any;
  sent_job_type_location_id: any;
  get_latest_service_rule_id: any;
  get_latest_service_timeframe_id: any;
  job_service_timeframe_count_types: any;
  job_service_timeframe_time_types: any;
  job_service_timeframe_time_when: any;
  job_service_timeframe_date_types: any;
  get_latest_variable_code_block_id: Object;
  variable_code_job_types: any;

  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
    private modalService: BsModalService, viewRef: ViewContainerRef
  ) { }

  ngOnInit() {

    this.model = new VariableCodeBlock();
    this.model.job_type_id = this.send_job_type_id;
    this.model.job_type_court_id = this.sent_job_type_court_id;
    this.getVariableCodeBlockTypes();
    this.getJobTypes();
    // get the rules sql
    // this.getJobServiceTimeframeCountTypes();
    // this.getJobServiceTimeframeTimeTypes();
    // this.getJobServiceTimeframeTimeWhen();
    // this.getJobServiceTimeframeDateTypes();
  }

  createVariableCodeBlock(model) {
  // console.log(model);
    this._demoService.createVariableCodeBlock(model).subscribe(
          data => {  this.get_latest_variable_code_block_id = data; // this is the retuned json upon creation.

            this.traceAddNotice ();
  /*
          // tslint:disable-next-line:max-line-length
          this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
          this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
  */
          this.closeParentModel.emit();
        //   CreateJobTypeComponent.returned.next(false);
            //  return true;
          },
          error => {
            this.toastr.error('Adding Block Failed :: Please try again!');
            // console.log(Observable.throw(error));
            // return Observable.throw(error);
          console.error(error);
          }
    );
    }

    getVariableCodeBlockTypes() {
    this._demoService.getVariableCodeBlockTypes().subscribe(
        data => { this.variable_code_job_types = data; },
        err => console.error(err),
        // () => console.log('done loading Trace Types')
      );
    }

  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
  
   getJobTypeLocations(job_type_id) {
    this._demoService.getJobTypeLocations(job_type_id).subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendJobTypeLocationsID(job_type_id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count2 = job_type_id;
    this.getJobTypeLocations(this.count2); // updates the selected job ID....
    this.model.job_type_location_id = 1;
    this.model.job_type_court_id = 0;
    // this.model.job_type_document_type_id = 0;
    // this.model.job_type_affidavit_type_id = 0;

  }



  getJobServiceTimeframeCountTypes() {
    this._demoService.getJobServiceTimeframeCountTypes().subscribe(
       data => { this.job_service_timeframe_count_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobServiceTimeframeTimeTypes() {
    this._demoService.getJobServiceTimeframeTimeTypes().subscribe(
       data => { this.job_service_timeframe_time_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobServiceTimeframeTimeWhen() {
    this._demoService.getJobServiceTimeframeTimeWhen().subscribe(
       data => { this.job_service_timeframe_time_when = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }

   getJobServiceTimeframeDateTypes() {
    this._demoService.getJobServiceTimeframeDateTypes().subscribe(
       data => { this.job_service_timeframe_date_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


  createJobServiceTimeframe(model) {
    // console.log(model);
        this._demoService.createJobServiceTimeframe(model).subscribe(
             data => {  this.get_latest_service_timeframe_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */
             this.closeParentModel.emit();
           //   CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Service Timeframe Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
              console.error(error);
             }
        );
        }





  createJobServiceRule(model) {
    // console.log(model);
        this._demoService.createJobServiceRule(model).subscribe(
             data => {  this.get_latest_service_rule_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */
             this.closeParentModel.emit();
           //   CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Service Rule Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
              console.error(error);
             }
        );
        }


  createJobTypeAffidavit(model) {
    // console.log(model);
        this._demoService.createJobTypeAffidavit(model).subscribe(
             data => {  this.get_latest_affidavit_id = data; // this is the retuned json upon creation.
     
               this.traceAddNotice ();
     /*
             // tslint:disable-next-line:max-line-length
             this.router.navigateByUrl('/manager/brand-client-manager/' + this.model.client_brand_id, {skipLocationChange: true}).then(() =>
             this.router.navigate(['/manager/brand-client-contact-manager/' + this.model.brand_id + '/' + this.model.client_brand_id]));
     */
             this.closeParentModel.emit();
           //   CreateJobTypeComponent.returned.next(false);
               //  return true;
             },
             error => {
               this.toastr.error('Adding Affidavit Failed :: Please try again!');
               // console.log(Observable.throw(error));
               // return Observable.throw(error);
             }
        );
        }
 
 
        traceAddNotice () {
         this.toastr.info('Service Timeframe Added');
       };
 



       getJobTypeCourts(job_type_location_id) {
        this._demoService.getJobTypeCourts(job_type_location_id).subscribe(
           data => { this.job_type_courts = data; },
           err => console.error(err),
           // () => console.log('done loading Trace Types')
         );
       }
      
      
       sendJobTypeCourtsID(job_type_location_id) {
        // this.initialCount = this.trace_candidates.trace_candidate_id;
        this.sent_job_type_location_id = job_type_location_id;
        this.getJobTypeCourts(this.sent_job_type_location_id); // updates the selected job ID....
      
      }


      getJobTypeDocumentTypes(job_type_court_id) {
        this._demoService.getJobTypeDocumentTypes(job_type_court_id).subscribe(
           data => { this.job_type_document_types = data; },
           err => console.error(err),
           // () => console.log('done loading Trace Types')
         );
       }
      
      
       sendJobTypeDocumentTypesID(job_type_court_id) {
        // this.initialCount = this.trace_candidates.trace_candidate_id;
        this.sent_job_type_court_id = job_type_court_id;
        this.getJobTypeDocumentTypes(this.sent_job_type_court_id); // updates the selected job ID....
    
      }




}

